import { useMemo, useState } from "react";
import { archiveItems } from "@/mocks/gossip";
import { getStateCfg } from "./stateStyle";

export default function ArchiveFeed() {
  const [keyword, setKeyword] = useState("");
  const [limit, setLimit] = useState(7);

  const list = useMemo(() => {
    const k = keyword.trim();
    const base = k
      ? archiveItems.filter((i) => i.subject.includes(k) || i.category.includes(k))
      : archiveItems;
    return base;
  }, [keyword]);

  const shown = list.slice(0, limit);

  return (
    <section id="archive" className="bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[300px_1fr]">
          {/* left intro + search */}
          <div>
            <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-secondary-500">
              旧帖速查 · 不必翻楼
            </p>
            <h2 className="font-display text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
              存档速查
              <br />
              按日期拉齐旧脉络
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              已收尾或已归档的九色黑料爆料都会落进这里。想回看某一天的九色黑料追踪进度，直接在搜索框敲关键词即可。
            </p>

            <div className="mt-5">
              <div className="flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2.5 focus-within:border-foreground-950">
                <i className="ri-search-line text-sm text-secondary-500"></i>
                <input
                  type="text"
                  value={keyword}
                  onChange={(e) => {
                    setKeyword(e.target.value);
                    setLimit(7);
                  }}
                  placeholder="搜标题 / 分舱，如：股权"
                  className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-secondary-400"
                />
              </div>
              <p className="mt-2 text-xs text-secondary-500">
                {list.length} 条存档匹配 · 按日期倒序排列
              </p>
            </div>
          </div>

          {/* dense archive rows */}
          <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
            <div className="grid grid-cols-[64px_1fr] items-center gap-3 border-b border-background-200 bg-background-100 px-4 py-2.5 text-xs font-semibold text-secondary-600 sm:grid-cols-[80px_120px_1fr]">
              <span>日期</span>
              <span className="hidden sm:block">状态</span>
              <span>存档条目</span>
            </div>
            <div className="divide-y divide-background-100">
              {shown.length === 0 && (
                <div className="px-4 py-10 text-center text-sm text-secondary-500">
                  没有搜到相关存档，换个关键词试试。
                </div>
              )}
              {shown.map((item) => {
                const s = getStateCfg(item.state);
                return (
                  <button
                    key={item.id}
                    type="button"
                    className="grid w-full grid-cols-[64px_1fr] items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-background-50 sm:grid-cols-[80px_120px_1fr]"
                  >
                    <span className="whitespace-nowrap font-mono text-sm text-foreground-700">{item.time}</span>
                    <span className="hidden sm:block">
                      <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold ${s.badge}`}>
                        <i className={`${s.icon} text-xs`}></i>
                        {item.state}
                      </span>
                    </span>
                    <span className="flex min-w-0 items-center justify-between gap-2">
                      <span className="truncate text-sm font-medium text-foreground-800">{item.subject}</span>
                      <span className="flex items-center gap-2">
                        <span className="whitespace-nowrap text-xs text-secondary-500">{item.category}</span>
                        <i className="ri-arrow-right-up-line text-sm text-secondary-400"></i>
                      </span>
                    </span>
                  </button>
                );
              })}
            </div>
            {limit < list.length && (
              <button
                type="button"
                onClick={() => setLimit((v) => v + 7)}
                className="flex w-full items-center justify-center gap-2 border-t border-background-200 bg-background-50 px-4 py-3 text-sm font-medium text-primary-700 hover:bg-primary-50"
              >
                <i className="ri-add-line"></i>
                查看更早存档（{list.length - limit}）
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}